import { useEffect, useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { Nav, Navbar, Offcanvas, Container } from 'react-bootstrap';
import { execSeatableSql } from './components/seatable.js';

import AOS from "aos";
import "aos/dist/aos.css"; 

// import logo from './assets/logo.png';
// import bgLogo from './assets/logo.png';

import './App.css';

import Home from './components/home.js';
import Capabilities from './components/capabilities.js';
import WhatWeDo from './components/whatwedo.js';
import Insights from './components/insights.js';
import AllPage from './components/allpage.js';
import Query from './components/query.js';
import FloatingAvatar from './components/avatar.js';

function App() {
  const [whatWeDo, setWhatWeDo] = useState(null);
  const [showWhatWeDo, setShowWhatWeDo] = useState(false);
  // const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [data, setData] = useState(null);
  const [gobalData, setGlobalData] = useState([]);


  useEffect(() => {
    async function fetchData() {
      const sql = `SELECT * FROM \`Pages\` WHERE \`IsActive\` IS TRUE ORDER BY \`Rank\``;
      setData(null);

      const sql1 = `SELECT * FROM \`SiteSettings\` WHERE \`IsActive\` IS TRUE`;

      try {
        const rows = await execSeatableSql(sql);
        setData(rows && rows.results);

        const rows1 = await execSeatableSql(sql1);
        setGlobalData(rows1 && rows1.results || []);
      } catch (err) {
        // setError(err);
      }
    }
    fetchData();
  }, []); 

  useEffect(() => {
    const handleScroll = () => {
      // if (window.scrollY > lastScrollY) {
      //   // scrolling down → hide navbar
      //   setShowNavbar(true);
      // } else {
      //   // scrolling up → show navbar
      //   setShowNavbar(true);
      // }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    AOS.init({
      // Optional: Configure AOS with desired settings
      duration: 1000, // Animation duration
      once: true, // Whether animation should only happen once
    });
    AOS.refresh(); // Refresh AOS to detect newly added elements
  }, []);

  const handleWhatWeDo = (event) => {
    // window.scrollTo(0, 0);
    const type = event.currentTarget.dataset.type;
    setWhatWeDo(type);
    setShowWhatWeDo(["Capabilities","Industries"].includes(type));
  };

  const closeWhatWeDo = (event) => {
    showWhatWeDo && setShowWhatWeDo(false);
  }

  const settingsMap = gobalData.reduce((acc, item) => {
    acc[item.Name] = {
      media: item.fnMediaLink,
      description: item.Description
    };
    return acc;
  }, {});

  useEffect(() => {
    if (!gobalData.length) return;

    if (settingsMap["SiteTitle"]?.description) {
      document.title = settingsMap["SiteTitle"].description;
    }
    console.log("")
    const faviconUrl = settingsMap["Favicon"]?.media;

    if (faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");

      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }

      link.href = faviconUrl;
    }

  }, [gobalData]);

  return (
    <div onMouseUp={closeWhatWeDo} className='position-relative'>
      <Navbar collapseOnSelect expand="md" data-bs-theme="dark" sticky="top" className={`m-0 p-1 app-navbar`}>
        <Container fluid className="m-0 p-0">
          <Navbar.Brand className='p-0 mx-1 d-flex justify-content-center' >
            <Link to={'/'} className="logo-link" onClick={() => window.scrollTo(0, 0)}>
              <img className="logo normal" src={settingsMap["Logo"]?.media}  alt={settingsMap["Logo"]?.description} />
              <img className="logo hover"  src={settingsMap["logo hover"]?.media} alt={settingsMap["logo hover"]?.description} />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="app-navbar-nav" className="ms-auto" />
          <Navbar.Offcanvas id='app-navbar-nav' placement="top" data-bs-theme="dark">
            <Offcanvas.Header closeButton>
              {/*
              <Offcanvas.Title id={`basic-navbar-offcanvas`}>
                ALLTEAM
              </Offcanvas.Title>
              */}
            </Offcanvas.Header>
            <Offcanvas.Body>
            <Nav className="mx-auto" >
              {data && data.map((row, index) => {return (<>
              {(row.LinkType === 'Page Group') ?
              <Nav.Link eventKey={index} as={Link} to="#" data-type={row.Name} onClick={handleWhatWeDo} >
                  <span>{row.Name}</span>
              </Nav.Link>
              : 
              <Nav.Link eventKey={index} as={Link} to={row.Slug}> 
                  <span>{row.Name}</span>
              </Nav.Link>
              }
              </>)})}
            </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
      <Container fluid className="m-0 p-0">
          <Routes>
            <Route exact path="/" element={<Home />} />

            {data && data.map((row, index) => {return (<>
            {(row.LinkType === 'Page Group') ?
            <Route exact path={row.Slug} element={<Capabilities />} />
            :(row.LinkType === 'Page') ?
            <Route key={row.Slug} exact path={row.Slug} element={<AllPage key={row.Slug} menuLevel={row.Name} hideFooter={row.HideFooter} showSubMenu={row.ShowSubMenu} subMenuHeading={row.SubMenuHeading} metaTitle={row.MetaTitle} metaDescription={row.MetaDescription}/>} />
            :(row.LinkType === 'Insights') ?
            <Route key={row.Slug} exact path="/insights" element={<Insights metaTitle={row.MetaTitle} metaDescription={row.MetaDescription}/>} />
            : ''}
           
            <Route exact path="/query" element={<Query />} />
            </>)})}
          </Routes>
      </Container>
      <div className={`nav-overlay ${showWhatWeDo ? 'd-flex' : 'd-none'}`}>
        <WhatWeDo type={whatWeDo} />
      </div>

      {/* Floating avatar window */}
      <FloatingAvatar setWhatWeDo={setWhatWeDo} whatWeDo={whatWeDo} setShowWhatWeDo={setShowWhatWeDo}/>
    </div>);
}

export default App;
